import { WixSDK } from '../polyfills/wix-sdk';
export var ImageService = {
    getResizedImageSize: function (currentWidth, currentHeight, maxWidth, maxHeight) {
        var ratio = Math.min(Math.max(maxWidth / currentWidth, maxHeight / currentHeight) * 2, 1);
        return {
            width: currentWidth * ratio,
            height: currentHeight * ratio,
        };
    },
    getImageStyle: function (url, width, height, position, opacity, size) {
        if (size === void 0) { size = 'cover'; }
        return ({
            backgroundImage: "url(" + WixSDK.Utils.Media.getResizedImageUrl(url, width, height) + ")",
            backgroundPosition: resolveImagePosition(position),
            backgroundRepeat: 'no-repeat',
            backgroundSize: size,
            opacity: opacity / 100,
        });
    },
};
var resolveImagePosition = function (position) {
    var horizontal = 'center', vertical = '';
    if (position % 3 === 0) {
        horizontal = 'right';
    }
    else if ((position - 1) % 3 === 0) {
        horizontal = 'left';
    }
    if (position < 4) {
        vertical = 'top';
    }
    else if (position < 7) {
        vertical = 'center';
    }
    else {
        vertical = 'bottom';
    }
    return horizontal + " " + vertical;
};
//# sourceMappingURL=image.js.map